import {Entity} from '@s-ui/domain'

import {LocationEntity} from './LocationEntity.js'

export class CityLocationEntity extends Entity {
  #city

  constructor({city}) {
    super()
    this.#city = city
  }

  static empty() {
    return new CityLocationEntity({city: LocationEntity.empty()})
  }

  static createFromLiterals({id, name}) {
    if (!LocationEntity.isValid({id})) return CityLocationEntity.empty()
    return new CityLocationEntity({city: LocationEntity.createFromLiterals({id, name})})
  }

  get id() {
    return this.#city.id
  }

  get name() {
    return this.#city.name
  }

  get value() {
    return this.#city.value
  }

  isEmpty() {
    return this.#city.isEmpty()
  }
}
